import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-full-info',
  templateUrl: './full-info.page.html',
  styleUrls: ['./full-info.page.scss'],
})
export class FullInfoPage implements OnInit {

  @Input() info: any;
  @Input() type:any;
  userInfo:any;

  constructor(public modalController:ModalController) { }

  ngOnInit() {
    this.userInfo = JSON.parse(this.info);
  }

    /**
   * @mathod { Dismiss the popup }
   * @memberof PopupPage
   */
  closePopup() {
    this.modalController.dismiss();
  }

}
